import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from "@bt/shared";
import { ChangePasswordComponent } from './change-password.component';
import { ChangePasswordFormComponent } from './form/component';
import { BrandModule } from "../brand/brand.module";
import { SetModuleComponent } from '@bt/admin-settings/set-module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    BrandModule,
  ],
  declarations: [
    ChangePasswordComponent,
    ChangePasswordFormComponent
  ],
})
export class ChangePasswordModule { }


// WEBPACK FOOTER //
// ./src/app/public/change-password/change-password.module.ts